import PropTypes from 'prop-types';
import { Fragment } from 'react';
import IntroAnimation from './IntroAnimation.jsx';
import AnimatedIcon from './AnimatedIcon.jsx';
import AccessibilityBar from './AccessibilityBar.jsx';
import './FloatingControls.css';

const FloatingControls = ({ theme, setTheme, accessibility, setAccessibility }) => {
  const toggleTheme = () => {
    setTheme(theme === 'dark' ? 'light' : 'dark');
  };

  const nextTheme = theme === 'dark' ? 'light' : 'dark';

  return (
    <div className="floating-controls" aria-label="Display and accessibility controls">
      {/* Accessibility button first (slides in from top), then theme toggle (slides in from top) */}
      <IntroAnimation delay={980} direction="right">
        <button
          type="button"
          className="floating-control-button"
          onClick={toggleTheme}
          aria-label={`Switch to ${nextTheme} theme`}
        >
          <AnimatedIcon name={theme === 'dark' ? 'sun' : 'moon'} />
        </button>
      </IntroAnimation>
      <IntroAnimation delay={460} direction="right">
        <Fragment>
          <AccessibilityBar accessibility={accessibility} setAccessibility={setAccessibility} inline />
        </Fragment>
      </IntroAnimation>

    </div>
  );
};

FloatingControls.propTypes = {
  theme: PropTypes.string.isRequired,
  setTheme: PropTypes.func.isRequired,
  accessibility: PropTypes.shape({
    textSize: PropTypes.string,
    highContrast: PropTypes.bool,
    reduceMotion: PropTypes.bool,
  }).isRequired,
  setAccessibility: PropTypes.func.isRequired,
};

export default FloatingControls;
